import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67f2f84b")

_pushScopeId("data-v-67f2f84b")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: "/media/icons/new/add.png",
  width: "30",
  height: "30"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("button", {
  class: "btn btn-icon noBorder",
  "data-bs-toggle": "tooltip",
  disabled: true
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/media/icons/new/add.png",
    width: "30",
    height: "30",
    class: "gray-icon"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return ($props.element && $props.isPlanning && !$props.isTypeUser && $props.element.type !== 'key_result')
    ? (_openBlock(), _createBlock("button", {
        key: 0,
        class: "btn btn-icon noBorder",
        id: "kt_objective_toggle",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "top",
        title: $setup.translate(`New`),
        disabled: $props.element && $props.element.type === 'key_result',
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.newSubObjective($props.element)))
      }, [
        _hoisted_1
      ], 8, ["title", "disabled"]))
    : ($props.element && $props.element.type !== 'key_result')
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          title: $setup.translate(`isPlanning`)
        }, [
          _hoisted_2
        ], 8, ["title"]))
      : _createCommentVNode("", true)
})